(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-interval-result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-interval-result.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$tur$lyckoplatsen = svs.tur.lyckoplatsen.map,
  createMap = _svs$tur$lyckoplatsen.createMap,
  mapDefaults = _svs$tur$lyckoplatsen.mapDefaults,
  sweRectangleBounds = _svs$tur$lyckoplatsen.sweRectangleBounds,
  worldRectangleBounds = _svs$tur$lyckoplatsen.worldRectangleBounds,
  locationToArray = _svs$tur$lyckoplatsen.locationToArray,
  get3dPinIcon = _svs$tur$lyckoplatsen.get3dPinIcon,
  disableInteraction = _svs$tur$lyckoplatsen.disableInteraction,
  enableInteraction = _svs$tur$lyckoplatsen.enableInteraction;
function getIntervalResultMapHandler() {
  let map;
  let mapId;
  let intervalPins = [];
  let singleWorldRec;
  let showCenterMapButton = false;
  let maxZoom;
  let minZoom;
  let justMovedToCenter = true;
  let clusterLayers = [];
  let currentZoom;
  let tlInterval;
  let pendingClusterOrigin = false;
  let zoomEndHandler = null;
  let disableMapInteraction = false;
  const eventHandlers = {};
  return {
    createMap(_ref) {
      let _ref$mapOptions = _ref.mapOptions,
        mapOptions = _ref$mapOptions === void 0 ? {} : _ref$mapOptions,
        _ref$evtHandlers = _ref.evtHandlers,
        evtHandlers = _ref$evtHandlers === void 0 ? {} : _ref$evtHandlers;
      Object.assign(eventHandlers, evtHandlers);
      const options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options);
      mapId = options.nodeId;
      maxZoom = options.maxZoom;
      minZoom = options.minZoom;
      this.handleZoomButtonsEvents();
      map.on('resize', _.debounce(() => {
        this.uiCenterMap();
      }, 300));
      map.on('move', () => {
        if (!justMovedToCenter) {
          showCenterMapButton = true;
          this.uiCenterMap();
        }
        justMovedToCenter = false;
      });
      map.on('movestart', () => {
        disableMapInteraction && disableInteraction(map);
      });
      map.on('moveend', () => {
        disableMapInteraction && enableInteraction(map);
        disableMapInteraction = false;
      });
      return map;
    },
    handleZoomButtonsEvents() {
      map.whenReady(() => {
        const mapContainer = document.getElementById(mapId);
        const zoomInButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-in');
        const zoomOutButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-out');
        if (zoomInButton) {
          zoomInButton.addEventListener('click', () => {
            const zoomLevel = map.getZoom();
            showCenterMapButton = true;
            const center = map.getCenter();
            map.setView(center, zoomLevel + 1, {
              animate: false
            });
            this.uiCenterMap();
          });
        }
        if (zoomOutButton) {
          zoomOutButton.addEventListener('click', () => {
            const zoomLevel = map.getZoom();
            showCenterMapButton = true;
            const center = map.getCenter();
            map.setView(center, zoomLevel - 1, {
              animate: false
            });
            this.uiCenterMap();
          });
        }
      });
    },
    fitBoundsSweden() {
      var _map;
      (_map = map) === null || _map === void 0 || _map.fitBounds(sweRectangleBounds, {
        minZoom,
        maxZoom
      });
    },
    showIntervalResult() {
      let results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      let evtHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      Object.assign(eventHandlers, evtHandlers);

      if (tlInterval) {
        tlInterval.kill();
        tlInterval = null;
      }
      if (zoomEndHandler) {
        map.off('zoomend', zoomEndHandler);
        zoomEndHandler = null;
      }
      this.clearMapPins();
      intervalPins.forEach(pin => {
        var _pin$remove;
        return pin === null || pin === void 0 || (_pin$remove = pin.remove) === null || _pin$remove === void 0 ? void 0 : _pin$remove.call(pin);
      });
      intervalPins = [];
      pendingClusterOrigin = false;
      intervalPins = results.map(_ref2 => {
        let productId = _ref2.productId,
          drawNumber = _ref2.drawNumber,
          location = _ref2.location;
        const pinIcon = get3dPinIcon({
          useSmallIcon: true
        });
        const pin = leaflet.marker(locationToArray(location), {
          icon: pinIcon,
          productId,
          drawNumber
        });
        if (pin) {
          pin.off('click');
          pin.on('click', () => {
            var _eventHandlers$interv;
            return (_eventHandlers$interv = eventHandlers.intervalPinClicked) === null || _eventHandlers$interv === void 0 ? void 0 : _eventHandlers$interv.call(eventHandlers, {
              productId,
              drawNumber
            });
          });
          pin.off('keypress');
          pin.on('keypress', ev => {
            if (ev.originalEvent.key === 'Enter') {
              var _eventHandlers$interv2;
              (_eventHandlers$interv2 = eventHandlers.intervalPinClicked) === null || _eventHandlers$interv2 === void 0 || _eventHandlers$interv2.call(eventHandlers, {
                productId,
                drawNumber
              });
            }
          });
          pin.addTo(map);
        }
        return pin;
      });
      this.updateClusters();
      this.animatePinsIn();
      zoomEndHandler = () => {
        this.updateClusters();
      };
      map.on('zoomend', zoomEndHandler);
    },
    animatePinsIn() {
      if (tlInterval) {
        tlInterval.kill();
      }
      requestAnimationFrame(() => {
        tlInterval = gsap.timeline();
        const mapContainer = document.getElementById(mapId);
        const pinElements = (mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelectorAll('.lp-3dpin .pin-image')) || [];
        if (pinElements.length > 0) {
          const maxTotalStagger = 2;
          const stagger = Math.min(0.15, maxTotalStagger / pinElements.length);
          tlInterval.set(pinElements, {
            opacity: 0,
            scale: 0,
            transformOrigin: '50% 100%'
          });
          tlInterval.to(pinElements, {
            opacity: 1,
            scale: 1,
            duration: 0.6,
            ease: 'back.out(1.7)',
            stagger
          });
        }
        tlInterval.play();
      });
    },
    clearMapPins() {
      [...intervalPins, ...clusterLayers].forEach(layer => map.removeLayer(layer));
      clusterLayers = [];
    },
    updateClusters() {
      const shouldAnimate = pendingClusterOrigin;
      pendingClusterOrigin = false;
      const oldClusterMap = new Map();
      if (shouldAnimate) {
        const oldClusters = this.createClusters(intervalPins, currentZoom);
        oldClusters.forEach(group => {
          if (group.length <= 1) {
            return;
          }
          const center = this.getClusterCenter(group);
          group.forEach(pin => {
            const idx = intervalPins.indexOf(pin);
            if (idx !== -1) {
              oldClusterMap.set(idx, center);
            }
          });
        });
      }
      this.clearMapPins();
      currentZoom = Math.round(map.getZoom());
      const clusters = this.createClusters(intervalPins, currentZoom);
      const groupToClusterIdx = new Map();
      clusters.forEach((group, groupIdx) => {
        if (group.length === 1) {
          group[0].addTo(map);
        } else {
          const latlng = this.getClusterCenter(group);
          let clusterMarker;
          if (currentZoom >= 15) {
            const clusterIcon = get3dPinIcon({
              count: group.length,
              useSmallIcon: true
            });
            clusterMarker = leaflet.marker(latlng, {
              icon: clusterIcon
            });
            clusterMarker.on('click', () => {
              let degrees = [0];
              if (group.length === 2) {
                degrees = [-30, 30];
              } else if (group.length === 3) {
                degrees = [-35, 0, 35];
              } else if (group.length === 4) {
                degrees = [-45, -15, 15, 45];
              } else if (group.length === 5) {
                degrees = [-50, -25, 0, 25, 50];
              }
              const clusterPixel = map.latLngToContainerPoint(clusterMarker.getLatLng());
              clusterMarker.remove();
              group.forEach((marker, index) => {
                var _marker$getElement;
                marker.addTo(map);
                const pinImage = (_marker$getElement = marker.getElement()) === null || _marker$getElement === void 0 ? void 0 : _marker$getElement.querySelector('.pin-image');
                if (pinImage) {
                  const pinPixel = map.latLngToContainerPoint(marker.getLatLng());
                  const offsetX = clusterPixel.x - pinPixel.x;
                  const offsetY = clusterPixel.y - pinPixel.y;
                  gsap.fromTo(pinImage, {
                    x: offsetX,
                    y: offsetY,
                    scale: 0,
                    opacity: 0
                  }, {
                    x: 0,
                    y: 0,
                    scale: 1,
                    opacity: 1,
                    rotation: degrees[index],
                    transformOrigin: '50% 100%',
                    duration: 0.5,
                    delay: index * 0.08,
                    ease: 'back.out(1.7)'
                  });
                }
              });
            });
          } else {
            const clusterIcon = get3dPinIcon({
              count: group.length,
              useSmallIcon: true
            });
            clusterMarker = leaflet.marker(latlng, {
              icon: clusterIcon
            });
            clusterMarker.on('click', () => {
              pendingClusterOrigin = true;
              disableMapInteraction = true;
              const nextZoom = Math.min(Math.round(currentZoom) + 2, 15);
              map.flyTo(latlng, nextZoom);
            });
          }
          clusterMarker.addTo(map);
          groupToClusterIdx.set(groupIdx, clusterLayers.length);
          clusterLayers.push(clusterMarker);
        }
      });
      if (shouldAnimate && oldClusterMap.size > 0) {
        clusters.forEach((group, groupIdx) => {
          const firstPinIdx = intervalPins.indexOf(group[0]);
          const oldOrigin = oldClusterMap.get(firstPinIdx);
          if (!oldOrigin) {
            return;
          }
          const originPixel = map.latLngToContainerPoint(oldOrigin);
          if (group.length === 1) {
            var _group$0$getElement;
            const pinImage = (_group$0$getElement = group[0].getElement()) === null || _group$0$getElement === void 0 ? void 0 : _group$0$getElement.querySelector('.pin-image');
            if (pinImage) {
              const pinPixel = map.latLngToContainerPoint(group[0].getLatLng());
              const offsetX = originPixel.x - pinPixel.x;
              const offsetY = originPixel.y - pinPixel.y;
              if (Math.abs(offsetX) < 1 && Math.abs(offsetY) < 1) {
                return;
              }
              gsap.fromTo(pinImage, {
                x: offsetX,
                y: offsetY,
                scale: 1
              }, {
                x: 0,
                y: 0,
                scale: 1,
                duration: 1,
                ease: 'back.out(1.7)'
              });
            }
          } else {
            var _clusterEl$getElement;
            const clusterLayerIdx = groupToClusterIdx.get(groupIdx);
            const clusterEl = clusterLayers[clusterLayerIdx];
            const pinImage = clusterEl === null || clusterEl === void 0 || (_clusterEl$getElement = clusterEl.getElement) === null || _clusterEl$getElement === void 0 || (_clusterEl$getElement = _clusterEl$getElement.call(clusterEl)) === null || _clusterEl$getElement === void 0 ? void 0 : _clusterEl$getElement.querySelector('.pin-image');
            if (pinImage) {
              const clusterLatLng = this.getClusterCenter(group);
              const pinPixel = map.latLngToContainerPoint(clusterLatLng);
              const offsetX = originPixel.x - pinPixel.x;
              const offsetY = originPixel.y - pinPixel.y;
              if (Math.abs(offsetX) < 1 && Math.abs(offsetY) < 1) {
                return;
              }
              gsap.fromTo(pinImage, {
                x: offsetX,
                y: offsetY,
                scale: 0
              }, {
                x: 0,
                y: 0,
                scale: 1,
                duration: 0.6,
                ease: 'back.out(1.7)'
              });
            }
          }
        });
      }
    },
    createClusters(pins, zoom) {
      const clusters = [];
      const visited = new Set();
      const radius = this.getClusterRadiusByZoom(zoom >= 15 ? 15 : zoom);
      pins.forEach((pin, i) => {
        if (visited.has(i)) {
          return;
        }
        const group = [pin];
        visited.add(i);
        const posA = pin.getLatLng();
        for (let j = i + 1; j < pins.length; j++) {
          if (visited.has(j)) {
            continue;
          }
          const posB = pins[j].getLatLng();
          const distance = posA.distanceTo(posB); 

          if (distance < radius) {
            group.push(pins[j]);
            visited.add(j);
          }
        }
        clusters.push(group);
      });
      return clusters;
    },
    getClusterRadiusByZoom(zoom) {
      const zoomLevel = Math.round(zoom);
      const zoomRadiusMap = {
        15: 5,
        14: 100,
        13: 200,
        12: 400,
        11: 800,
        10: 1500,
        9: 3000,
        8: 6000,
        7: 40000,
        6: 60000,
        5: 75000,
        4: 90000 
      };
      return zoomRadiusMap[zoomLevel] || 100000; 
    },
    getClusterCenter(pins) {
      const latSum = pins.reduce((sum, p) => sum + p.getLatLng().lat, 0);
      const lngSum = pins.reduce((sum, p) => sum + p.getLatLng().lng, 0);
      return leaflet.latLng(latSum / pins.length, lngSum / pins.length);
    },
    removeIntervalResult() {
      intervalPins.forEach(pin => {
        var _pin$remove2;
        return pin === null || pin === void 0 || (_pin$remove2 = pin.remove) === null || _pin$remove2 === void 0 ? void 0 : _pin$remove2.call(pin);
      });
      intervalPins = [];
    },
    centerMap() {
      this.fitBoundsSweden();
      showCenterMapButton = false;
      justMovedToCenter = true;
      this.uiCenterMap();
    },
    uiCenterMap() {
      if (showCenterMapButton) {
        eventHandlers.showCenterMapButton(true);
      } else {
        eventHandlers.showCenterMapButton(false);
      }
    },
    addWorldRectangle() {
      var _singleWorldRec;
      singleWorldRec = leaflet.rectangle(worldRectangleBounds, {
        fillColor: '#001E3C',
        fillOpacity: 0.72,
        stroke: false,
        className: 'world-rect',
        renderer: leaflet.svg({
          padding: 0.85
        })
      });
      (_singleWorldRec = singleWorldRec) === null || _singleWorldRec === void 0 || _singleWorldRec.addTo(map);
      singleWorldRec.on('click', ev => {
        leaflet.DomEvent.stopPropagation(ev);
        eventHandlers.highlightedWinGroup(null);
      });
    },
    removeMap() {
      map.remove();
      map = null;
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getIntervalResultMapHandler
});

 })(window);